import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import HeroWeb3 from "./HeroWeb3";
import Web3Features from "./Web3Features";
import Possibilities from "./Possibilities";
import LetsBuild from "./LetsBuild";
import WhyChooseXeer from "../../DeFi/DeFiStaking/WhyChooseXeer";

function Web3Development() {
  return (
    <div className="web3-development-page">
      <Header />
      <HeroWeb3 />
      <Web3Features />
      <LetsBuild />
      <Possibilities />
      <WhyChooseXeer />
      <Footer />
    </div>
  );
}

export default Web3Development;
